import { ArtOrderFull } from "@/api/art-order/types";
import ArtOrderItem from "../ArtOrderItem/ArtOrderItem";
import { Pagination } from "@/app/(components)/Basic/Pagination";
import { twMerge } from "tailwind-merge";
import { ART_ORDER_PAGE_SIZE } from "../constants";
import NoRecordDialog from "@/app/(components)/Basic/NoRecordDialog";

export interface Props {
  items?: ArtOrderFull[];
  currentPage: number;
  itemsCount: number;
  className?: string;
  baseUrl: string;
}

const ArtOrderItems = ({
  items,
  currentPage,
  itemsCount,
  className,
  baseUrl,
}: Props) => {
  return (
    <>
      {items?.length ? (
        <div className={twMerge(className, "flex flex-col")}>
          <Pagination
            itemsCount={itemsCount}
            currentPage={currentPage}
            itemsPerPage={ART_ORDER_PAGE_SIZE}
            baseUrl={baseUrl}
          />
          <div className="hidden lg:flex xl:gap-x-16 gap-x-8 items-center border-b pb-4 pt-2 px-10">
            <span className="text-xs text-endemicGray-700 w-40 text-center shrink-0 endemic:text-white">
              AUTHOR
            </span>
            <span className="text-xs text-endemicGray-700 w-full endemic:text-white">
              ORDER DETAILS
            </span>
            <span className="text-xs text-endemicGray-700 w-[202px] mr-5 text-center shrink-0 endemic:text-white">
              STATUS
            </span>
          </div>
          {items.map((item, index) => {
            return (
              <ArtOrderItem
                key={index}
                id={item.id}
                author={item.author}
                title={item.title}
                shortDescription={item.shortDescription}
                maxBudget={item.maxBudget}
                budgetPaymentERC20TokenAddress={
                  item.budgetPaymentERC20TokenAddress
                }
                status={item.status}
              />
            );
          })}
          <Pagination
            itemsCount={itemsCount}
            currentPage={currentPage}
            itemsPerPage={ART_ORDER_PAGE_SIZE}
            baseUrl={baseUrl}
          />
        </div>
      ) : (
        <NoRecordDialog className="mt-20" message="No orders yet" />
      )}
    </>
  );
};

export default ArtOrderItems;
